// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IParticipantAddressInfoDto } from './IParticipantAddressInfoDto';
import {
    IParticipantAddressInfoDtoFromJSON,
    IParticipantAddressInfoDtoFromJSONTyped,
    IParticipantAddressInfoDtoToJSON,
    IParticipantAddressInfoDtoToJSONTyped,
} from './IParticipantAddressInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeInfoAdminPatchDto
 */
export interface IEmployeeInfoAdminPatchDto {
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoAdminPatchDto
     */
    mailing_address?: IParticipantAddressInfoDto;
}

/**
 * Check if a given object implements the IEmployeeInfoAdminPatchDto interface.
 */
export function instanceOfIEmployeeInfoAdminPatchDto(value: object): value is IEmployeeInfoAdminPatchDto {
    return true;
}

export function IEmployeeInfoAdminPatchDtoFromJSON(json: any): IEmployeeInfoAdminPatchDto {
    return IEmployeeInfoAdminPatchDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoAdminPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoAdminPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mailing_address': json['mailing_address'] == null ? undefined : IParticipantAddressInfoDtoFromJSON(json['mailing_address']),
    };
}

export function IEmployeeInfoAdminPatchDtoToJSON(json: any): IEmployeeInfoAdminPatchDto {
    return IEmployeeInfoAdminPatchDtoToJSONTyped(json, false);
}

export function IEmployeeInfoAdminPatchDtoToJSONTyped(value?: IEmployeeInfoAdminPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mailing_address': IParticipantAddressInfoDtoToJSON(value['mailing_address']),
    };
}

